import React from 'react';
import Icon from '../Icon';
import {ButtonStepper, Container, Error, Number} from './styled';

type CounterProps = {
  value: number;
  onDecrement?: () => void;
  onIncrement?: () => void;
  disabled?: boolean;
  error?: string | boolean;
  minNumber?: number;
  maxNumber?: number;
};

const Counter = ({
  value,
  error,
  onIncrement,
  onDecrement,
  disabled,
  minNumber = 0,
  maxNumber = 20,
}: CounterProps) => {
  return (
    <>
      <Container>
        <ButtonStepper
          disabled={disabled || value === minNumber}
          onClick={event => {
            event.stopPropagation();
            event.preventDefault();
            !disabled && onDecrement?.();
          }}
          type="button"
          aria-label="Decrease"
        >
          <Icon name="minus" size="24" />
        </ButtonStepper>
        <Number>{value}</Number>
        <ButtonStepper
          disabled={disabled || value === maxNumber}
          onClick={event => {
            event.stopPropagation();
            event.preventDefault();
            !disabled && onIncrement?.();
          }}
          type="button"
          aria-label="Increase"
        >
          <Icon name="plus" size="24" />
        </ButtonStepper>
        {error && <Error>{error}</Error>}
      </Container>
    </>
  );
};

export {Counter};
